import React from "react";
import { TabContent, TabPane } from "reactstrap";
import { useSearchParams } from "react-router-dom";

import Pricing from "../../pages/DashboardCrypto/Pricing/Pricing";
import MarketGraph from "../../pages/DashboardCrypto/MarketGraph/MarketGraph";
import History from "../../pages/DashboardCrypto/History";
import Dashboard from '../../pages/crm-pages/Dashboard'
import Settings from "../../pages/DashboardCrypto/Settings";
import OpenPositionsMobile from "../../pages/DashboardCrypto/openPositions/OpenPositionsMobile";

const TabContentComponent = () => {
    const [searchParams] = useSearchParams();
    const activeTab = searchParams.get("tab") || "1"; // Use URL for active tab

    return (
        <TabContent activeTab={activeTab} className="text-muted h-100">
            <TabPane tabId="1">
                <Pricing/>
            </TabPane>
            <TabPane tabId="2">
                <Pricing />
            </TabPane>
            <TabPane tabId="3">
                <OpenPositionsMobile />
            </TabPane>
            <TabPane tabId="4" className="h-100">
                <MarketGraph />
            </TabPane>
            <TabPane tabId="5">
                <History />
            </TabPane>
            <TabPane tabId="6">
                <Settings />
            </TabPane>
        </TabContent>
    );
};

export default TabContentComponent;
